import { useState } from "react";
import { MediaItem } from "@/types/common";

interface MediaPreviewState {
  selectedMedia: MediaItem[];
  selectedPhoto: string | null;
  selectedVideo: string | null;
}

interface MediaPreviewActions {
  handleMediaClick: (type: "image" | "video", url: string) => void;
  setSelectedPhoto: (value: string | null) => void;
  setSelectedVideo: (value: string | null) => void;
}

export type MediaPreviewReturn = MediaPreviewState & MediaPreviewActions;

const useMediaPreview = (allMedia: MediaItem[]): MediaPreviewReturn => {
  const [selectedMedia, setSelectedMedia] = useState<MediaItem[]>([]);
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const handleMediaClick = (type: "image" | "video", url: string) => {
    setSelectedMedia(allMedia);

    if (type === "image") {
      setSelectedPhoto(url);
      setSelectedVideo(null);
    } else {
      setSelectedVideo(url);
      setSelectedPhoto(null);
    }
  };

  return {
    selectedMedia,
    selectedPhoto,
    selectedVideo,
    handleMediaClick,
    setSelectedPhoto,
    setSelectedVideo,
  };
};

export default useMediaPreview;
